// extracted by mini-css-extract-plugin
export default {"content":"InfoSalaryResume_content__jmI36","fields":"InfoSalaryResume_fields__qAP49"};